<mat-dialog-content>
  <lemon-dialog-header> Jaa kulu usealle kuukaudelle </lemon-dialog-header>

  <form novalidate style="margin: 0">
    <div class="form-row">
      <mat-form-field class="form-field">
        <mat-label>Ensimmäinen kuukausi</mat-label>
        <input type="text" [matDatepicker]="ekaPicker" monthPicker [formField]="lomake.ekaKuukausi" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="ekaPicker"></mat-datepicker-toggle>
        @if (onkoVirhe(lomake.ekaKuukausi, 'required')) {
          <mat-error>Päivämäärä puuttuu</mat-error>
        }
        @if (onkoVirhe(lomake.ekaKuukausi, 'loppuEnnenAlkua')) {
          <mat-error>Viimeinen kuukausi on ennen ensimmäistä</mat-error>
        }
      </mat-form-field>
      <mat-datepicker #ekaPicker></mat-datepicker>

      <mat-form-field class="form-field">
        <mat-label>Viimeinen kuukausi</mat-label>
        <input type="text" [matDatepicker]="vikaPicker" monthPicker [formField]="lomake.vikaKuukausi" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="vikaPicker"></mat-datepicker-toggle>
        @if (onkoVirhe(lomake.vikaKuukausi, 'required')) {
          <mat-error>Päivämäärä puuttuu</mat-error>
        }
        @if (onkoVirhe(lomake.vikaKuukausi, 'loppuEnnenAlkua')) {
          <mat-error>Viimeinen kuukausi on ennen ensimmäistä</mat-error>
        }
      </mat-form-field>
      <mat-datepicker #vikaPicker></mat-datepicker>
    </div>
  </form>

  @if (virhe) {
    <div class="error-text" style="font-size: 120%; padding: 15px">
      {{ virhe }}
    </div>
  }

  <div style="margin-top: 2em">
    <div style="margin-bottom: 1em">
      <span class="left-col">Kuukausien lukumäärä:</span>
      <span class="right-col">{{ kuukausienLukumaara() ?? ' - ' }} </span>
    </div>

    @for (kulu of kulut(); track kulu) {
      <div style="margin-bottom: 1em">
        <div>{{ kulu.tili }}</div>
        <div>
          <span class="left-col">Jaettava kulu yhteensä:</span>
          <span class="right-col">{{ kulu.yhteensa | lmoneyl: 'EUR' : 'fi' }}</span>
        </div>
        <div>
          <span class="left-col">Kulu per kuukausi:</span>
          <span class="right-col">{{ kulu.perKuukausi ? (kulu.perKuukausi | lmoneyl: 'EUR' : 'fi') : ' - ' }}</span>
        </div>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: space-around; justify-content: space-evenly">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (kirjaus jaksota kulu dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="jaaKulu()" actionId="Kirjaus jaettu kulu" [actionContext]="[lomake().value()]">Jaa kulu</app-primary-button>
</mat-dialog-actions>
